import { date as commonDate } from '@finley-technologies/common';

import { ErrorToastConfig, SuccessToastConfig } from 'types/dashboard.d';

export const numericRegex = /(?=.*[0-9])/;

export const errorToastId = 'errorToastId';
export const errorToastBaseConfig = {
  status: 'error',
  duration: 6000,
  position: 'top',
  isClosable: true,
} as const;
export const errorToastConfig: ErrorToastConfig = {
  ...errorToastBaseConfig,
  id: errorToastId,
};

export const errorToastAdminConfig: ErrorToastConfig = {
  id: errorToastId,
  status: 'error',
  isClosable: true,
  duration: null,
  position: 'top',
};

export const warnToastId = 'warnToastId';
export const warnToastConfig: ErrorToastConfig = {
  id: warnToastId,
  duration: 6000,
  status: 'warning',
  isClosable: true,
  position: 'top',
};

export const toastId = 'toastId';
export const successToastBaseConfig = {
  status: 'success',
  duration: 6000,
  position: 'top',
  isClosable: true,
} as const;
export const successToastConfig: SuccessToastConfig = {
  ...successToastBaseConfig,
  id: toastId,
};

export const dashboardRoutePadding = '40px';

// init conditions: 3 years from current
export const getDefaultDashboardDisplayEndDate = () =>
  commonDate.currentDateStr();
// this is the number of days before current day that various dashboard areas (eg. portfolio insights) should default to
// 3 years default load until we have global filters
const defaultDashboardDisplayDays: number = 365 * 3;
export const getDefaultDashboardDisplayStartDate = () =>
  commonDate.addDays(
    getDefaultDashboardDisplayEndDate(),
    -defaultDashboardDisplayDays,
  );
